// import { , callPost, callPutById, callDelete } from "../integrations/calls";
import { callPost, callGet, callPut } from "../integrations/calls";

import { REQ } from "../../libs/constants";

export const getStockBal = async (data, token) => {
  return await callPost(REQ.ALL_REPORTS.GET_STOCK_BALENCE, data, token);
};

export const getDayBook = async (data, token) => {
  return await callPost(REQ.ALL_REPORTS.GET_DAY_BOOK, data, token);
};

export const getGLedger = async (data, token) => {
  return await callPost(REQ.ALL_REPORTS.GET_GENERAL_LEDGER, data, token);
};

export const getStockSummaryRateWise = async (data, token) => {
  return await callPost(REQ.ALL_REPORTS.GET_STOCK_SUMMARY_RATEWISE, data, token);
};

export const getStockOrder = async (data, token) => {
  return await callPost(REQ.ALL_REPORTS.GET_STOCK_ORDER, data, token);
};

export const getPLedger = async (data, token) => {
  return await callPost(REQ.ALL_REPORTS.GET_PARTY_LEDGER, data, token);
};

export const getStockReg = async (data, token) => {
  return await callPost(REQ.ALL_REPORTS.GET_STOCK_REG, data, token);
};

export const getPurchaseReg = async (data, token) => {
  return await callPost(REQ.ALL_REPORTS.GET_PURCHASE_REG, data, token);
};

export const getSaleReg = async (data, token) => {
  return await callPost(REQ.ALL_REPORTS.GET_SALE_REG, data, token);
};

export const getTrialBal = async (data, token) => {
  return await callPost(REQ.ALL_REPORTS.GET_TRIAL_BAL, data, token);
};

export const getDailySheet = async (data, token) => {
  return await callPost(REQ.ALL_REPORTS.GET_DAILY_SHEET, data, token);
};

export const getPartyBill = async (data, token) => {
  return await callPost(REQ.ALL_REPORTS.GET_PARTY_BILL, data, token);
};

export const getPartyBulkBill = async (data, token) => {
  return await callPost(REQ.ALL_REPORTS.GET_PARTY_BILL_BULK, data, token);
};

export const getPartyBulkBillSummary = async (data, token) => {
  return await callPost(REQ.ALL_REPORTS.GET_PARTY_BILL_BULKSUMMARY, data, token);
};

export const getCustomerBillSummary = async (data, token) => {
  return await callPost(REQ.ALL_REPORTS.GET_CUSTOMER_BILL_SUMMARY, data, token);
};

export const getCustomerBillSummaryItemWise = async (data, token) => {
  return await callPost(
    REQ.ALL_REPORTS.GET_CUSTOMER_BILL_SUMMARY_ITEM_WISE,
    data,
    token
  );
};

export const getCreditSaleSheetEWise = async (data, token) => {
  return await callPost(REQ.ALL_REPORTS.GET_CREDIT_SHEET, data, token);
};

export const getCreditSaleSheetVWise = async (data, token) => {
  return await callPost(
    REQ.ALL_REPORTS.GET_CREDIT_SHEET_VEHICLE_WISE,
    data,
    token
  );
};

export const getProfitLoss = async (data, token) => {
  return await callPost(REQ.ALL_REPORTS.GET_PROFIT_LOSS, data, token);
};

export const getVehicleExp = async (data, token) => {
  return await callPost(REQ.ALL_REPORTS.GET_VEHICLE_EXP, data, token);
};

export const getRateGain = async (data, token) => {
  return await callPost(REQ.ALL_REPORTS.GET_RATE_GL, data, token);
};

export const getBulkSaleReport = async (data, token) => {
  return await callPost(REQ.ALL_REPORTS.GET_BULK_SALE_REPORT, data, token);
};

export const getBulkSaleTaxReport = async (data, token) => {
  return await callPost(REQ.ALL_REPORTS.GET_SALETAX_REPORT, data, token);
};

export const getBulkSalePurchaseRegister = async (data, token) => {
  return await callPost(
    REQ.ALL_REPORTS.GET_BULK_SALE_PURCHASE_REG,
    data,
    token
  );
};

export const getNSalePurchaseRegister = async (data, token) => {
  return await callPost(
    REQ.ALL_REPORTS.GET_N_SALE_PURCHASE_REG,
    data,
    token
  );
};

export const getPendingApprovals = async (token) => {
  return await callGet(REQ.ALL_REPORTS.GET_PENDING_APPROVALS, token);
};

export const getPendingBulkSaleApprovals = async (token) => {
  return await callGet(REQ.ALL_REPORTS.GET_PENDING_BULKSALE_APPROVALS, token);
};

export const getPendingPurchaseApprovals = async (token) => {
  return await callGet(REQ.ALL_REPORTS.GET_PENDING_PURCHASE_APPROVALS, token);
};

export const updatePendingApprovals = async (data, token) => {
  return await callPut(
    `${REQ.ALL_REPORTS.UPDATE_PENDING_APPROVALS}/${data.id}`,
    data,
    token
  );
};

export const updatePendingBulkSaleApprovals = async (data, token) => {
  return await callPut(
    `${REQ.ALL_REPORTS.UPDATE_PENDING_BULKSALE_APPROVALS}/${data.id}`,
    data,
    token
  );
};

export const updatePendingPurchaseApprovals = async (data, token) => {
  return await callPut(
    `${REQ.ALL_REPORTS.UPDATE_PENDING_PURCHASE_APPROVALS}/${data.id}`,
    data,
    token
  );
};

export const getSaleTaxReport = async (data, token) => {
  return await callPost(REQ.ALL_REPORTS.GET_BULK_SALE_REPORT, data, token);
};

export const getMonthlyExp = async (data, token) => {
  return await callPost(REQ.ALL_REPORTS.YEARLY_EXP, data, token);
};

export const glPosting = async (data, token) => {
  return await callPost(REQ.ALL_REPORTS.GLPOSTING, data, token);
};